import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import setup from './modules/setup'
import referral from './modules/referral'
import VuexPersistence from 'vuex-persist'
import Cookies from 'js-cookie'

const vuexSession = new VuexPersistence({
    storage: window.sessionStorage,
    modules: ['setup']
})
const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ['auth']
});

const COOKIE_VALIDITY_DAYS = 30;

const vuexCookie = new VuexPersistence({
    restoreState: (key) => Cookies.getJSON(key),
    saveState: (key, state) =>
        Cookies.set(key, state, {
            expires: COOKIE_VALIDITY_DAYS,
            samesite: 'strict'
        }),
    modules: ['referral'], //only save user module
})

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        setup,
        referral
    },
    plugins:[vuexSession.plugin, vuexLocal.plugin, vuexCookie.plugin]
})
